$(document).ready(function() {
  var tabLinks = $('.cgt-desc .link');

  tabLinks.on('click', function() {
    var dataValue = $(this).data("id");
    var selectedElement = $(`#${dataValue}`);
    var tabContents = $('.product-tabs .tab');

    tabContents.css('display', 'none');
    $(this).siblings().removeClass('active');
    
    selectedElement.css('display', 'block');
    $(this).addClass('active');
  });

  $(".add-to-cart-btn").on("click", function() {
    const productId = $(this).data('id');
    // Prepare the data to send
    var data = {
      items: [
        {
          id: productId,
          quantity: 1 // You can adjust the quantity as needed
        }
      ]
    };

    // Make the AJAX request to add the product to the cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js", // Replace with your store's URL
      dataType: "json",
      data: data,
      success: function(response) {
        console.log("Product added to cart:", response);
        // Handle success, e.g., show a success message or update the cart icon
        getCartQuantity();
        window.location.href = 'https://buyincellderm.com/cart';
      },
      error: function(xhr, status, error) {
        console.error("Error adding product to cart:", error);
        // Handle errors, e.g., show an error message to the user
      }
    });
  });
  
  function getCartQuantity() {
    // Make the AJAX request to fetch the cart data
    $.ajax({
      type: "GET",
      url: "/cart.js", // Replace with your store's URL
      dataType: "json",
      success: function(cartData) {
        // Extract the cart quantity from the response
        var cartQuantity = 0;
        if (cartData && cartData.item_count) {
          cartQuantity = cartData.item_count;
        }

        console.log("Cart Quantity:", cartQuantity);

        if (cartQuantity >= 1) {
          $('#cart-icon-bubble').append('<span class="cart-count-bubble"></span>');
        }
        $('.cart-count-bubble').html('<span>' +  cartQuantity + '</span>');
      },
      error: function(xhr, status, error) {
        console.error("Error fetching cart data:", error);
        // Handle errors, e.g., show an error message to the user
      }
    });
  }
});